<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<button
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				mat-icon-button
				color="primary"
				(click)="createNewMedia()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[actionsAvailable]="toggleActions"
				[itemsCount]="vo.list.elements.size"
				[actions]="panelActions"
				(refresh)="refresh()"
				(search)="search($event)">
				<div panel-title class="app-panel__title">
					<mat-icon [svgIcon]="HdIcons.Media"></mat-icon>
					<span i18n="@@media.list.title">Médias</span>
				</div>
				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{ id: 'media-list', class: 'app-media-list' }"
					[dataSource]="vo.list.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="false"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					[noDataText]="''"
					(onRowClick)="navigateToMedia($event.data)"
					(onCellHoverChanged)="onCellHover($event)"
					(onSelectionChanged)="onSelectionChange($event)"
					(onContentReady)="onGridContentReady()">
					<dxo-selection
						mode="multiple"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="vo.isFirstLoad"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'code'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[minWidth]="100"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="labelTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'type'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="typeTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'tags'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[filterOperations]="[DxOperations.Contains, DxOperations.In]"
							[calculateFilterExpression]="calculateTagsHeaderFilterExpression"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="tagsTemplate">
							<dxo-header-filter
								[dataSource]="tagsHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'updateDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="updateDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'creationDate'"
							[dataField]="col.field"
							[dataType]="col.type"
							[format]="col.format"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="creationDateTemplate"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'updatedByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[
								DxOperations.Contains,
								DxOperations.NotContains,
								DxOperations.StartsWith,
								DxOperations.In
							]"
							[calculateFilterExpression]="
								calculateActionByHeaderFilterExpression
							"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="updatedByAvatarTemplate">
							<dxo-header-filter
								[dataSource]="modifiedByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'createdByAvatar'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="[
								DxOperations.Contains,
								DxOperations.NotContains,
								DxOperations.StartsWith,
								DxOperations.In
							]"
							[calculateFilterExpression]="
								calculateActionByHeaderFilterExpression
							"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="createdByAvatarTemplate">
							<dxo-header-filter
								[dataSource]="actionByHeaderFilter"></dxo-header-filter>
						</dxi-column>
						<dxi-column
							*ngIf="col.field === 'isActive'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[dataType]="col.type"
							[format]="col.format"
							[visible]="col.visible"
							[filterValue]="col.filterValue"
							[filterValues]="col.filterValues"
							[sortIndex]="col.sortIndex"
							[sortOrder]="col.sortOrder"
							[width]="col.width ?? 200"
							cellTemplate="statusTemplate">
							<dxo-header-filter
								[dataSource]="actifHeaderFilter"></dxo-header-filter>
						</dxi-column>
					</ng-container>

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="vo.list.availableColumns.size + 1"
						[showInColumnChooser]="false"
						[width]="'10rem'"
						cellTemplate="actionsTemplate"></dxi-column>

					<div *dxTemplate="let cell of 'statusTemplate'">
						<app-badge class="status" *ngIf="!cell.data['isActive']">
							<span i18n="@@general.inactive">inactive</span>
						</app-badge>
					</div>

					<div class="label-template" *dxTemplate="let cell of 'labelTemplate'">
						<img
							[src]="cell.data['pictogramUrl']"
							[alt]="cell.data['pictogramUrl']" />
						<span class="label-template__label">
							{{ cell.data['label'] }}
						</span>
					</div>

					<div class="type-template" *dxTemplate="let cell of 'typeTemplate'">
						<img
							*ngIf="cell.data['type'] == 'image'"
							alt="Image"
							src="./src/img/icons/dc-media-image.svg" />
						<img
							*ngIf="cell.data['type'] == 'pdf'"
							alt="PDF"
							src="./src/img/icons/dc-media-pdf.svg" />
					</div>

					<div *dxTemplate="let cell of 'tagsTemplate'">
						<app-tag-configurator
							*ngIf="cell.data['tags'].length !== 0"
							displayMode="tags"
							configMode="View"
							[configuredTags]="cell.data['tags']"></app-tag-configurator>
					</div>

					<div *dxTemplate="let cell of 'updateDateTemplate'">
						<span>
							{{ cell.data['updateDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>
					<div *dxTemplate="let cell of 'creationDateTemplate'">
						<span>
							{{ cell.data['creationDate'] | date: 'yyyy-MM-dd HH:mm' }}
						</span>
					</div>

					<div
						*dxTemplate="let cell of 'updatedByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['updatedByAvatar']"
							[avatar]="cell.data['updatedByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>
					<div
						*dxTemplate="let cell of 'createdByAvatarTemplate'"
						class="avatar-template">
						<app-avatar
							*ngIf="cell.data['createdByAvatar']"
							[avatar]="cell.data['createdByAvatar']"
							[withTooltip]="true"></app-avatar>
					</div>

					<div
						class="actions-column-template"
						*dxTemplate="let cell of 'actionsTemplate'">
						<ng-container>
							<div [hidden]="cell.rowIndex !== currentlyHovered">
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-view-btn"
									mat-icon-button
									class="actions-column-template__btn"
									matTooltip="view-media"
									i18n-matTooltip="@@media.list.action.view"
									(click)="navigateToMedia(cell.data, true)">
									<mat-icon [svgIcon]="DcIcons.View"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-duplicate-btn"
									mat-icon-button
									class="actions-column-template__btn"
									matTooltip="duplicate-media"
									i18n-matTooltip="@@media.list.action.duplicate"
									(click)="duplicateMedia($event, cell.data)">
									<mat-icon [svgIcon]="ActionIcons.DuplicateElement"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
									mat-icon-button
									class="actions-column-template__btn"
									matTooltip="delete-dash"
									i18n-matTooltip="@@media.list.action.delete"
									(click)="deleteMedia($event, cell.data)">
									<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
									mat-icon-button
									class="actions-column-template__btn"
									(click)="rowMenuOpen($event, cell.rowIndex)"
									[matMenuTriggerFor]="
										cell.data['isActive'] ? activeActions : disabledActions
									"
									[matMenuTriggerData]="{ $implicit: cell.data }">
									<mat-icon
										[svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
								</button>
							</div>
						</ng-container>
						<mat-menu #activeActions="matMenu">
							<ng-template matMenuContent let-data>
								<button
									*ngFor="let a of activeRowActions"
									id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
									(click)="a.action(data)"
									mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>
						<mat-menu #disabledActions="matMenu">
							<ng-template matMenuContent let-data>
								<button
									*ngFor="let a of disabledRowActions"
									id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
									(click)="a.action(data)"
									mat-menu-item>
									<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
									<span>{{ a.description }}</span>
								</button>
							</ng-template>
						</mat-menu>

					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Filterable columns	-->
					<dxo-filter-row
						[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="pageSize"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowPageSizes"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>

					<!-- State persistence	-->
					<dxo-state-storing
						type="custom"
						[enabled]="true"
						[savingTimeout]="160"
						[customLoad]="loadState"
						[customSave]="saveState"></dxo-state-storing>
				</dx-data-grid>
				<ng-container
					*ngIf="!vo.isLoading && vo.list.elements.size === 0"
					[ngTemplateOutlet]="noData"></ng-container>
			</app-panel>
		</app-page-content>
	</app-page>
</ng-container>

<ng-template #noData>
	<div class="no-data-template">
		<mat-icon [svgIcon]="HdIcons.Media"></mat-icon>
		<app-button
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddCircle"
			i18n="@@media.list.action.new"
			(click)="createNewMedia()">
			new-media
		</app-button>
	</div>
</ng-template>
